"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PunchCorrectionButton = void 0;
const react_1 = __importDefault(require("react"));
const react_i18next_1 = require("react-i18next");
const Button_1 = require("@amzn/atoz-web/Button");
const Text_1 = require("@amzn/atoz-web/Text");
const Theme_1 = require("@amzn/atoz-web/Theme");
const MessageBanner_1 = require("@amzn/atoz-web/MessageBanner");
const PunchCorrectionButton = ({ selectedDate, dashboardPath }) => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const StyledButton = (0, Theme_1.styledWithTheme)(Button_1.Button) `
        marginTop: \`20px\`,
        align: \`center\`,
        display: \`flex\`,
        width: \`100%\`
    `;
    const navigateToMissedPunchWidget = () => {
        const searchParams = new URLSearchParams({ date: selectedDate });
        const targetUrl = `${dashboardPath}?${searchParams.toString()}`;
        location.assign(targetUrl);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(MessageBanner_1.MessageBanner, { dataTestId: "punch-correction-button-missed-punch-banner", type: MessageBanner_1.MessageBannerType.Error },
            react_1.default.createElement(Text_1.Text, { fontWeight: "bold" }, t('time_and_attendance_PunchCorrectionButton_BannerHeader')),
            t('time_and_attendance_PunchCorrectionButton_BannerDescription')),
        react_1.default.createElement(StyledButton, { key: "PunchCorrectionRedirectButton", variant: Button_1.ButtonVariant.Primary, onClick: navigateToMissedPunchWidget, dataTestId: "punch-correction-redirect-button" }, t('time_and_attendance_PunchCorrectionButton_CorrectPunches'))));
};
exports.PunchCorrectionButton = PunchCorrectionButton;
